import { combineReducers } from '@reduxjs/toolkit';

import accommodation from './accommodation';
import common from '../common';
import cruise from './cruise';
import labels from './labels';
import message from './message';
import searchInformation from './searchInformation';
import transport from './transport';

// `common` is seeded through `preloadedState`, so this is a plain reducer map — see
// redux/store/cabinListStore.js.
const cabinListApp = combineReducers({
  accommodation,
  common,
  cruise,
  labels,
  message,
  searchInformation,
  transport,
});

export default cabinListApp;
